<template>
  <el-select v-model="schemeid" :placeholder="placeholder" :size="size" @change="handleChange" filterable clearable :style="{ width: width }">
    <el-option
      v-for="item in schemes"
      :key="item.schemeid"
      :label="item.title"
      :value="item.schemeid">
      <div class="flex align-items-center">
        <span class="bd">{{ item.title }}</span>
        <span v-if="item.scheme_unit === 'year'" class="ml ft">
          {{ item.scheme_price | currency }}/年
        </span>
      </div>
    </el-option>
  </el-select>
</template>

<script>
import { allSchemeApi } from '@/api/ei/eiApi'

export default {
  props: {
    value: {
      type: [Number, String],
      default: undefined
    },
    width: {
      type: String,
      default: '100%'
    },
    placeholder: {
      type: String,
      default: '收费方案'
    },
    size: {
      type: String,
      default: ''
    },
    showUnset: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      schemes: [],
    }
  },

  computed: {
    schemeid: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },

  created() {
    this.fetchData()
  },

  methods: {
    fetchData() {
      allSchemeApi().then(res => {
        if (res.errno === 0) {
          const arr = [{ schemeid: 0, title: '未加载' }]
          this.schemes = this.showUnset ? arr.concat(res.data.list) : res.data.list
        }
      })
    },

    handleChange(val) {
      const list = this.schemes.map((v) => v.schemeid)
      const index = list.indexOf(val)
      const item = this.schemes[index]
      this.$emit('change', item)
    }
  }
}
</script>
